import React from "react";
import "../landing.css";
import BookHereButton from "../buttons/BookHereButton";

const Book = () => {
  return (
    <div className="landing-section-book">
      <h1 className="book-section-title">
        Meet MINDSAI at CES 2025 - Book Now!
      </h1>
      <BookHereButton />
    </div>
  );
};

export default Book;
